<template lang="pug">
v-card
  v-toolbar(flat, dense)
    .subtitle-2 Edit Customer Address
  simple-table(v-if="order")
    tbody
      tr
        td {{ order.seller.name }}
        td.text-right \#{{ order.orderNumber }}
      tr
        td {{ order.customer.name }}
        td.text-right {{ order.customer.phone | phone }}
      tr(v-for="(item, index) in order.payment.selflane.items", :key="index")
        td {{ item.name }}
        td.text-right {{ item.value | currency }}
  v-divider.mb-3
  v-card-text
    v-form(@submit.prevent="submit")
      v-row(wrap, dense)
        v-col(cols="8")
          GoogleAddressField(v-model="address")
        v-col(cols="4")
          v-text-field(
            label="Apt, room",
            v-model="address.line2",
            hide-details
          )
        v-col(cols="12")
          v-text-field(
            label="Delivery Note",
            v-model="address.note",
            hide-details
          )
      .text-center.sl-title Distance: {{ geoDistance2.value | number(1) }} {{ geoDistance2.unit }}
      v-btn.text-capitalize(
        block,
        type="submit",
        color="secondary",
        :loading="loading"
      ) Edit Customer Address
</template>

<script>
import { mapActions } from "vuex";
import BizUtils from "/libs/utils/biz.js";

export default {
  props: ["order"],
  data() {
    return {
      loading: false,
      address: {},
    };
  },
  computed: {
    distanceUnit() {
      if (this.order?.seller?.address?.country == "CA") return "km";
      return "mi.";
    },
    geoDistance2() {
      let a = this.order?.seller?.address?.geometry;
      let b = this.address?.geometry;
      if (a && b && b.lat) {
        return BizUtils.geoDistance2(a, b, this.distanceUnit);
      }
      return {};
    },
  },
  methods: {
    ...mapActions(["updateOrder"]),
    async submit() {
      if (!this.order) return;
      const params = {
        orderId: this.order._id,
        address: this.address,
      };
      this.loading = true;
      try {
        const { data } = await this.axios.post("/orders/editAddress", params);
        this.updateOrder(data);
        this.dialog = false;
        this.address = {};
        this.$emit("done");
      } catch (e) {
        this.$toast.error(e.response?.data || e.message);
      }
      this.loading = false;
    },
  },
};
</script>
